import { Component, OnInit, SimpleChanges, Input } from '@angular/core';
import { GlobalSearchService } from '../Services/global-search.service';
import { SearchResults, NewsArticles } from '../Models/common.model';
import { paginate } from '../Models/common.pagination';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VideoModalPopupComponent } from '../Components/video-modal-popup.component';

@Component({
  selector: 'video-search',
  templateUrl: './video-search.component.html',
})
export class VideoSearchComponent implements OnInit {
    @Input() public loadingMessage: string;

    page = 1;
    pageSize = 10;
    maxPages = 10;
    startIndex: number;
    endIndex: number;
    pager: any = {};
    isLoading: boolean = true;
    searchQuery: string;
    searchTag: string;
    isTextSearch: boolean = false;
    private _searchText: string;
    get searchText(): string {
        return this._searchText;
    }
    set searchText(value: string) {
        this._searchText = value;
    }

    private _searchResults: SearchResults<NewsArticles>;
    get searchResults(): SearchResults<NewsArticles> {
        return this._searchResults;
    }
    set searchResults(value: SearchResults<NewsArticles>) {
        this._searchResults = value;
    }
    constructor(public dataService: GlobalSearchService, private modalService: NgbModal) {
    }

    ngOnInit(): void {
        this.peformSearch();

        this.dataService.getStaticData().subscribe((data: string) => {
            this.loadingMessage = data;
        })
    }

    ngOnChanges(changes: SimpleChanges) {
        // reset page if items array has changed
        if (changes.items.currentValue !== changes.items.previousValue) {
            this.onChangePage(this.page);
        }
    }

    searchService(page, searchString) {
        this.dataService.getVideoSearchKeywordResults(page, searchString).subscribe((data: SearchResults<NewsArticles>) => {
            this.pageSize = data.PageSize;
            this.searchResults = data;
            this.setPage(this.searchResults);
            this.isLoading = false;

            window.location.href = "#topofbody";
        })
    }

    peformSearch(): void {
        this.isTextSearch = false;
        this.isLoading = true;

        this.dataService.getVideoSearchResults(this.page).subscribe((data: SearchResults<NewsArticles>) => {
            this.pageSize = data.PageSize;
            this.searchResults = data;
            this.setPage(this.searchResults);
            this.isLoading = false;

            window.location.href = "#topofbody";
        })

    }

    performTextSearch(event) {
        this.isTextSearch = true;
        this.isLoading = true;
        this.page = 1;

        if (this.searchText != null || this.searchText != undefined) {
            this.searchService(this.page, this.searchText)
        }
    }

    onChangePage(pageIndex: any) {
        if (this.isTextSearch) {
            if (this.searchText != null || this.searchText != undefined) {
                this.searchService(this.page, this.searchText)
            }
        }
        else {
            this.peformSearch();
        }
        
    }

    setPage(searchResults: SearchResults<NewsArticles>) {
        this.pager = paginate(searchResults.TotalMatching, this.page, this.pageSize, this.maxPages);

        //set nnumber of items per pages.
        this.startIndex = this.pager.startIndex + 1;
        this.endIndex = this.pager.endIndex + 1;
    }

    showModalPopup(videoUrl: string) {
        const modalRef = this.modalService.open(VideoModalPopupComponent, { size: 'lg', scrollable: true });
        modalRef.componentInstance.videoUrl = videoUrl;
    }

}
